<span *ngIf="user&&this.fullName" (click)="user.person?this.viewUserDetail(user):''" [pTooltip]="fullName">
  <i class="fas  {{user.identifier === 'AUTOMATICO'?'fa-user-cog':'fa-user'}}" aria-hidden="true"></i>
  <span *ngIf="user.identifier !== 'AUTOMATICO'">{{' [' + this.user.identifier + ']'}}</span>
  <span class="d-block">{{this.fullName}}</span><i class="fa-solid fa-user-gear"></i>
</span>
<!--span *ngIf="user" class="d-xs-inline-block" (click)="this.viewUserDetail(user)" [pTooltip]="fullName">
<i class="far fa-lg fa-user" aria-hidden="true"></i> <span> {{this.lettersName}}</span>
</span-->